<div class="board-container box-black-third rounded-6">
  @for (tile of minesService.currentGame().grid; track $index) {
  <app-mines-tile
    [isOpened]="
      minesService.currentGame().status === 'finished'
        ? minesService.currentGame().grid.indexOf(tile - 1) === tile
        : minesService.clicked().includes(tile)
    "
    [isBomb]="minesService.minesPosition().includes(tile)"
    [opacityEffect]="
      (!minesService.currentGame().won &&
        !minesService.clicked().includes(tile)) ||
      (minesService.minesPosition().includes(tile) &&
        minesService.clicked().at(-1) !== tile) ||
      !minesService.clicked().includes(tile)
    "
    [tile]="tile"
    (click)="minesService.checkMine(tile)"
  />
  }
</div>
